import { useState, useEffect } from 'react';
import {
  isPreviewMode,
  setPreviewMode,
  isBannerDismissed,
  dismissBanner
} from '../utils/previewMode';

/**
 * Hook for managing new shop preview mode in React components
 * Returns current preview mode status and functions to control it
 */
export function usePreviewMode() {
  const [previewMode, setPreviewModeState] = useState(isPreviewMode);
  const [bannerDismissed, setBannerDismissed] = useState(isBannerDismissed);

  useEffect(() => {
    // Listen for preview mode changes from other components
    const handlePreviewModeChange = (event: Event) => {
      const customEvent = event as CustomEvent<{ enabled: boolean }>;
      setPreviewModeState(customEvent.detail.enabled);
    };

    // Listen for banner dismissal from other components
    const handleBannerDismissed = () => {
      setBannerDismissed(true);
    };

    window.addEventListener('previewModeChange', handlePreviewModeChange);
    window.addEventListener('previewBannerDismissed', handleBannerDismissed);

    return () => {
      window.removeEventListener('previewModeChange', handlePreviewModeChange);
      window.removeEventListener('previewBannerDismissed', handleBannerDismissed);
    };
  }, []);

  const toggle = () => {
    window.location.replace('/catalog');
    
    //const newValue = togglePreviewMode();
    //setPreviewModeState(newValue);

    // Reset banner dismissed state when toggling on
    //if (newValue) {
    //  setBannerDismissed(false);
    //}

    //return newValue;
  };

  const enable = () => {
    setPreviewMode(true);
    setPreviewModeState(true);
    setBannerDismissed(false);
  };

  const disable = () => {
    window.location.replace('/catalog');
    //setPreviewMode(false);
    //setPreviewModeState(false);
  };

  const dismissWelcomeBanner = () => {
    dismissBanner();
    setBannerDismissed(true);
  };

  return {
    isPreviewMode: previewMode,
    showWelcomeBanner: previewMode && !bannerDismissed,
    toggle,
    enable,
    disable,
    dismissWelcomeBanner,
  };
}
